/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Codes
 */
export interface Codes {
    /**
     * 
     * @type {string}
     * @memberof Codes
     */
    typeCode: string;
    /**
     * 
     * @type {string}
     * @memberof Codes
     */
    typeName: string;
    /**
     * 
     * @type {number}
     * @memberof Codes
     */
    sortOrder: number;
    /**
     * 
     * @type {boolean}
     * @memberof Codes
     */
    defaultFlg: boolean;
}

/**
 * Check if a given object implements the Codes interface.
 */
export function instanceOfCodes(value: object): value is Codes {
    if (!('typeCode' in value) || value['typeCode'] === undefined) return false;
    if (!('typeName' in value) || value['typeName'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('defaultFlg' in value) || value['defaultFlg'] === undefined) return false;
    return true;
}

export function CodesFromJSON(json: any): Codes {
    return CodesFromJSONTyped(json, false);
}

export function CodesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Codes {
    if (json == null) {
        return json;
    }
    return {
        
        'typeCode': json['type_code'],
        'typeName': json['type_name'],
        'sortOrder': json['sort_order'],
        'defaultFlg': json['default_flg'],
    };
}

export function CodesToJSON(json: any): Codes {
    return CodesToJSONTyped(json, false);
}

export function CodesToJSONTyped(value?: Codes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type_code': value['typeCode'],
        'type_name': value['typeName'],
        'sort_order': value['sortOrder'],
        'default_flg': value['defaultFlg'],
    };
}

